<script setup>
  import { ref, onMounted, watch } from 'vue';
  import { useUserStore } from '@/stores/UserStore';
  import { useUpdateKey } from '@/composables/useUpdateKey';
  import SpotList from '@/components/SpotList.vue';
  import useSettingsGlobals from '@/composables/useSettingsGlobals';

  const { $ADS_ALLOWED } = useSettingsGlobals();

  const emit = defineEmits(['loaded', 'detail', 'spotListSorted']);

  const userStore = useUserStore();
  const updateKey = useUpdateKey()

  const isLoading = ref(true);

  const fetchSpots = async () => {
    isLoading.value = true;
    let data = null;
    
    data = await userStore.getSpotDetailSetByProfile(); // Uses currentProfileId in UserStore

    if (data && data.spots) {
      emit('loaded', data);
    }

    isLoading.value = false;
  };

  onMounted(() => {
    fetchSpots();
  });

  watch(() => [userStore.currentProfileId, updateKey.key], () => {
    fetchSpots();
  });
  
</script>

<template>
  <div class="jwx-spot-list-container">
    <div v-if="isLoading" class="jwx-spot-list-loader">
      <p>Loading weather stations...</p>
    </div>
    <div v-else-if="userStore.favoriteSpotData.spots.length === 0" class="jwx-p-jumbo">
      <p class="jwx-text jwx-font-size-lg jwx-text-center jwx-m-jumbo">You have no favorited spots.</p>
    </div>
    <SpotList
      v-else
      :data="userStore.favoriteSpotData.spots"
      :showLocalTimestamp="true"
      :showAds="userStore.showAds"
    />
  </div>
</template>
